import { render, staticRenderFns } from "./AddMeasures.vue?vue&type=template&id=388ee9d5"
import script from "./AddMeasures.vue?vue&type=script&lang=js"
export * from "./AddMeasures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports